import '../styles/stepOne.css'
import { useState,useRef, useContext } from 'react';
import AppContext from '../context/formContext'

const StepOne = () => {

    const {setForm} = useContext(AppContext)

    const usernameRef = useRef(null)
    const emailRef = useRef(null)
    const phoneRef = useRef(null)

    const [personalInfo, setPersonalInfo] = useState({})
    const [label , setLabel] = useState('Phone Number')

    const checkValidity = (e) => {
        e.preventDefault();
     
        if (!((phoneRef.current.value).length === 11)) {
            setLabel('phone number should have 11 numbers')
            return
        }
        else {
            setPersonalInfo({
            username: usernameRef.current.value,
            email: emailRef.current.value,
            phone: phoneRef.current.value
            })
            setLabel('Phone Number')
            setForm(2)
        }
    }

 

    return (
        <div className="stepOneCard">
            <section>
                <h1>Personal info</h1>
                <p>Please provide your name, email address, and phone number.</p>
            </section>
            <form onSubmit={(e)=>checkValidity(e)}>
                <div className="name">
                    <label htmlFor="name">Name</label>
                    <input type="text" id="name" placeholder="e.g. Stephen King" ref={usernameRef} value={personalInfo.username}  required />
                </div>
                <div className="email">
                    <label htmlFor="email">Email Address</label>
                    <input type="email" id="email" placeholder="e.g. stephenking@lorem.com" ref={emailRef} value={personalInfo.email} required />
                </div>
                <div className="phone">
                    <label htmlFor="phone">{label}</label>
                    <input type="number" id="phone" placeholder="e.g. +1 234 567 890" ref={phoneRef} value={personalInfo.phone} required/>
                </div>
                    <button className="nextBtn">Next Step</button>
            </form>
        </div>
    );
}
 
export default StepOne;